import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import CloseButton from './close-button'
import AlertIcon from '../images/icons/alert.svg'

const CalloutContainer = styled.div`
  padding: 12px 24px;
  display: flex;
`

const TableCalloutContainer = styled.div`
  padding: 5px 13px;
  display: flex;
`

const IconContainer = styled.div`
  margin-right: 15px;
`

const ButtonContainer = styled.div`
  margin-top: -0.375rem;
  margin-right: -0.2rem;
`

const containerStyles: any = {
  info: {
    backgroundColor: `${colours.lightPurpleBackground}`
  },
  action: {
    backgroundColor: `${colours.aquaBackground}`
  },
  warning: {
    backgroundColor: `${colours.lightGreenBackground}`
  },
  error: {
    backgroundColor: `${colours.errorBackground}`,
    color: `${colours.error}`
  }
}

interface IProps {
  type: string
  showDismissButton?: boolean
  onDismiss?: any
  children?: any
  inTable?: boolean
}

interface IState {}

const Callout = class extends React.Component<IProps, IState> {
  renderContents = () => {
    const { type, showDismissButton, onDismiss, children, inTable } = this.props
    return (
      <>
        {['warning', 'error'].includes(type) && (
          <IconContainer>
            <AlertIcon style={inTable ? { height: '13px' } : { height: '20px' }}></AlertIcon>
          </IconContainer>
        )}
        <div>{children}</div>
        <ButtonContainer>{showDismissButton && <CloseButton onClick={onDismiss} />}</ButtonContainer>
      </>
    )
  }

  render() {
    const { type, inTable } = this.props
    return inTable ? (
      <TableCalloutContainer style={containerStyles[type]}>{this.renderContents()}</TableCalloutContainer>
    ) : (
      <CalloutContainer style={containerStyles[type]}>{this.renderContents()}</CalloutContainer>
    )
  }
}

export default Callout
